// ------------------------------------
// Coleta central de tracking — dispara os eventos de conversão (InitiateCheckout,
// AddToCart, AddPaymentInfo, Purchase, CardRefused) de forma assíncrona pro
// core/acoes/marketing/dispatch.php, sem bloquear o carregamento da página.
// A tag client-side de cada plataforma (fbq/ttq/gtag/...) continua rodando
// normalmente nos arquivos de core/acoes/marketing/*_pixels.php — isso aqui só
// cuida do envio pra API (CAPI/Events API/Measurement Protocol).
// ------------------------------------

(function () {
  const infosBase = document.getElementById('infos-base');
  if (!infosBase) return;

  const csrfToken = infosBase.dataset.csrfToken || '';
  const tenantId = parseInt(infosBase.dataset.tenantId || '0', 10);
  const dispatchUrl = (window.URL_BASE || window.urlBase || '/') + 'core/acoes/marketing/dispatch.php';

  let trackingPixels = [];
  try {
    trackingPixels = JSON.parse(infosBase.dataset.trackingPixels || '[]');
  } catch (e) {
    trackingPixels = [];
  }

  function getCookie(name) {
    const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function gaClientIdFromCookie() {
    const ga = getCookie('_ga');
    if (!ga) return '';
    const parts = ga.split('.');
    return parts.length >= 4 ? parts[2] + '.' + parts[3] : '';
  }

  // fbc/fbp/ttclid/click-ids do Google SEMPRE lidos do cookie no momento do disparo —
  // nunca gerados/assumidos aqui. Se ainda não existirem (ex: 1ª pageview antes do
  // fbevents.js rodar), o campo fica vazio e o Adapter do lado do servidor decide o que fazer.
  function readTrackingIdentifiers() {
    return {
      fbc: getCookie('_fbc'),
      fbp: getCookie('_fbp'),
      ttclid: getCookie('ttclid'),
      gclid: getCookie('gclid'),
      gbraid: getCookie('gbraid'),
      wbraid: getCookie('wbraid'),
      ga_client_id: gaClientIdFromCookie(),
    };
  }

  function dispatch(eventName, options) {
    if (!tenantId || !csrfToken || trackingPixels.length === 0) return;
    options = options || {};

    const payload = {
      csrf_token: csrfToken,
      tenant_id: tenantId,
      event_name: eventName,
      event_id:
        options.eventId || 'EV-' + Date.now().toString(36) + Math.random().toString(36).slice(2).toUpperCase(),
      reference_type: options.referenceType,
      reference_id: String(options.referenceId || ''),
      source_url: window.location.origin + window.location.pathname,
      tenant_slug: infosBase.dataset.store || '',
      pixels: trackingPixels,
      user_data: Object.assign(readTrackingIdentifiers(), options.userData || {}),
      commerce: options.commerce || {},
    };

    if (!payload.reference_id) return;

    try {
      fetch(dispatchUrl, {
        method: 'POST',
        keepalive: true,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).catch(function () {
        // Falha de rede não deve afetar a navegação do cliente — sem retry aqui,
        // fica registrado como pendente/falho do lado do servidor se chegou a reservar.
      });
    } catch (e) {
      /* fetch indisponível (navegador muito antigo) — sem fallback síncrono de propósito. */
    }
  }

  // Consome os eventos que o render embutiu em data-tracking-events (mesmo
  // formato que os arquivos core/acoes/marketing/*_pixels.php empilham).
  function dispatchQueuedEvents() {
    let events = [];
    try {
      events = JSON.parse(infosBase.dataset.trackingEvents || '[]');
    } catch (e) {
      events = [];
    }
    events.forEach(function (evt) {
      dispatch(evt.event_name, {
        eventId: evt.event_id,
        referenceType: evt.reference_type,
        referenceId: evt.reference_id,
        commerce: evt.commerce,
        // Bug corrigido: user_data (nome/e-mail/telefone/endereço, montado com cuidado
        // em core/acoes/marketing/facebook_pixels.php) estava sendo descartado aqui —
        // nunca era repassado pro dispatch(), então nunca saía no payload pra API.
        userData: evt.user_data,
      });
    });
  }

  window.LpqvTracking = {
    dispatch: dispatch,
    readTrackingIdentifiers: readTrackingIdentifiers,

    // Chamado pelo order.js antes de montar o FormData do pedido: injeta os
    // identificadores atuais (fbc/fbp/click-ids) no hidden input 'extra_infos',
    // pra ficarem persistidos em orders.extra e disponíveis pro disparo vindo
    // de webhook (Pix/boleto confirmados depois, sem o cliente na aba).
    refreshExtraInfos: function () {
      const input = document.querySelector('input[name="extra_infos"]');
      if (!input) return;
      let extra = {};
      try {
        extra = JSON.parse(input.value || '{}');
      } catch (e) {
        extra = {};
      }
      Object.assign(extra, readTrackingIdentifiers());
      input.value = JSON.stringify(extra);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dispatchQueuedEvents);
  } else {
    dispatchQueuedEvents();
  }
})();
